// Logo.js — full FerrumIQ lockup: PulseMark + "FerrumIQ" wordmark (v3).
// Use `onDark` on the navy bar / dark surfaces — inverts the tile and
// lightens the "IQ" accent to inkOnDark. Faithful port of components/brand/Logo.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';
import { PulseMark } from './PulseMark';

export function Logo({ size = 28, onDark = false, style = {} }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.45, ...style }}>
      <PulseMark size={size} invert={onDark} />
      <span
        style={{
          fontFamily: v3.font.family,
          fontSize: size * 0.6,
          fontWeight: v3.font.weight.bold,
          letterSpacing: '-0.03em',
          lineHeight: 1,
          color: onDark ? '#FFFFFF' : v3.color.body,
        }}
      >
        Ferrum
        <span style={{ color: onDark ? v3.color.inkOnDark : v3.color.ink, fontWeight: v3.font.weight.semibold }}>
          IQ
        </span>
      </span>
    </span>
  );
}
